<template>
  <div class="waitingEvaluate">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
      <i class="iconfont icon-educesuan-icon topicon"></i>
      <p class="tip">提交成功，额度测算中……</p>
      <p class="smallTip">
        银行将在24小时内给出预授信结果<br />
        您可手动下拉本页面刷新审批结果
      </p>
      <div class="box"></div>
    </van-pull-refresh>
  </div>
</template>

<script>
/**
 * 等待初审结果页面
 */
// @ is an alias to /src
import { checkStatus } from './mixin';

export default {
  name: 'Testing',
  data() {
    return { isLoading: false };
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color:#fff');
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.$store.dispatch('commonForms/checkCurrentStatus', true);
        this.isLoading = false;
      }, 500);
    },
  },
  mixins: [checkStatus],
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
  mounted() {
    this.$store.dispatch('commonForms/checkCurrentStatus');
  },
};
</script>
<style scoped>
.bgColor {
  height: 100%;
  background-color: #fff;
}
.van-loading__spinner--spinner i::before {
  width: 4px;
  border-radius: 2px;

}
.waitingEvaluate {
  height: 100%;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}
.smallTip {
  color: #9ea7b4;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
}
.box {
  width: 100%;
  height: 200px;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #F65249;
  font-size: 60px;
}
</style>
